import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { DataComponent } from './steps/data/data.component';
import { ResponsibleComponent } from './steps/responsible/responsible.component';
import { FirstLimitComponent } from './steps/first-limit/first-limit.component';
import { ResponsibleDocumentsComponent } from './steps/responsible-documents/responsible-documents.component';
import { MoreInfoComponent } from './steps/more-info/more-info.component';
import { SecondLimitComponent } from './steps/second-limit/second-limit.component';
import { DocumentsComponent } from './steps/documents/documents.component';
import { ConfirmationComponent } from './steps/confirmation/confirmation.component';
import { NgxCurrencyModule, CurrencyMaskInputMode } from 'ngx-currency';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OnboardingSuccessModalComponent } from './steps/responses/onboarding-success-modal/onboarding-success-modal.component';
import { BankAccountComponent } from './steps/bank-account/bank-account.component';
import { MatRadioModule } from '@angular/material/radio';
import { IndividualDataComponent } from './steps/pf/individual-data/individual-data.component';
import { FatcaPepComponent } from './steps/pf/fatca-pep/fatca-pep.component';
import { IndividualDocumentsComponent } from './steps/pf/individual-documents/individual-documents.component';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

const routes: Routes = [
  { path: 'data', component: DataComponent },
  { path: 'individual-data', component: IndividualDataComponent },
  { path: 'individual-documents', component: IndividualDocumentsComponent },
  { path: 'fatca-pep', component: FatcaPepComponent },
  { path: 'responsible', component: ResponsibleComponent },
  { path: 'bank-account', component: BankAccountComponent },
  { path: 'first-limit', component: FirstLimitComponent },
  { path: 'responsible-documents', component: ResponsibleDocumentsComponent },
  { path: 'more-info', component: MoreInfoComponent },
  { path: 'second-limit', component: SecondLimitComponent },
  { path: 'company-documents', component: DocumentsComponent },
  { path: 'register-confirmation', component: ConfirmationComponent },
];

@NgModule({
  declarations: [
    DataComponent,
    ResponsibleComponent,
    FirstLimitComponent,
    BankAccountComponent,
    IndividualDocumentsComponent,
    OnboardingSuccessModalComponent,
    IndividualDataComponent,
    ResponsibleDocumentsComponent,
    MoreInfoComponent,
    SecondLimitComponent,
    DocumentsComponent,
    ConfirmationComponent,
    FatcaPepComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatInputModule,
    MatRadioModule,
    MatCheckboxModule,
    MatFormFieldModule,
    SharedComponentsModule,
    DirectivesModule,
  ],
})
export class OnboardingsModule {}
